import { useEffect } from 'react';

const setHeadLink = (rel, href) => {
  if (!href) return;

  const selector = rel === 'icon' ? "link[rel*='icon']" : `link[rel='${rel}']`;
  let link = document.querySelector(selector);

  if (!link) {
    link = document.createElement('link');
    link.rel = rel;
    document.head.appendChild(link);
  }

  link.href = href;
};

const setMetaContent = (name, content) => {
  if (!content) return;

  let meta = document.querySelector(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = name;
    document.head.appendChild(meta);
  }

  meta.content = content;
};

/**
 * Sets document title, favicon, and meta description from property data.
 *
 * @param {Object} [property] - Property with name, description, logoUrl
 * @param {Object} [options]
 * @param {string} [options.titleSuffix] - Appended to property name (e.g. " – Panel")
 */
export const useDocumentBranding = (property, options = {}) => {
  const { titleSuffix = '' } = options;

  useEffect(() => {
    document.documentElement.lang = 'pl';
  }, []);

  useEffect(() => {
    if (property?.name) {
      document.title = titleSuffix ? `${property.name}${titleSuffix}` : property.name;
    }

    setMetaContent('description', property?.description);

    if (property?.logoUrl) {
      setHeadLink('icon', property.logoUrl);
      setHeadLink('apple-touch-icon', property.logoUrl);
    }
  }, [property?.name, property?.description, property?.logoUrl, titleSuffix]);
};
